import * as REDUX_TYPES from '../types'

const INITIAL_STATE = {
    accruedCredits: [],
    currentArtistCredits: 0,
    currentCredits: 0,
    currentPromotionalCredits: 0,
    creditPlayTime: 1,
}

const creditsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REDUX_TYPES.CREDITS.ACCRUED_CREDITS:
            return {
                ...state,
                accruedCredits: action.accruedCredits,
            }
        case REDUX_TYPES.CREDITS.CURRENT_ARTIST_CREDITS:
            return {
                ...state,
                currentArtistCredits: action.currentArtistCredits,
            }
        case REDUX_TYPES.CREDITS.CURRENT_CREDITS:
            return {
                ...state,
                currentCredits: action.currentCredits,
            }
        case REDUX_TYPES.CREDITS.CURRENT_PROMOTIONAL_CREDITS:
            return {
                ...state,
                currentPromotionalCredits: action.currentPromotionalCredits,
            }
        case REDUX_TYPES.CREDITS.CREDIT_PLAY_TIME:
            return {
                ...state,
                creditPlayTime: action.creditPlayTime,
            }
        case REDUX_TYPES.CREDITS.RESET:
            return INITIAL_STATE
        default:
            return state
    }
}
export default creditsReducer